import { GetServerSideProps, GetStaticProps, InferGetStaticPropsType } from 'next';
import { ssrLiveNav, useLiveNavSnapshot } from 'lib/ssr/live-nav';

import { AmbienteContext } from 'context/Ambiente';
import { AppFragment } from 'enums/path-fragment';
import { Layout } from 'components/Layout';
import PageContent from 'components/page-content/ippica-detail/PageContent';
import { Seo } from 'components/seo';
import { cleanConfig } from 'lib/datoCms/utils';
import { getDatoCMSData } from 'sites/snai/lib/datoCms/queries/getDatoCMSData';
import { getIppicaAvvenimentoPage } from 'lib/datoCms/queries/getIppicaAvvenimentoPage';
import { isTruthy } from 'utility/functions';

const Ippica = ({
  site,
  header,
  footer,
  seoData,
  liveNav,
  needHelp,
  cmsContent,
  sidebarInstantGame,
  allMightLikes,
}: InferGetStaticPropsType<GetStaticProps>) => {
  useLiveNavSnapshot(liveNav);
  const { seoMetaTags, canonical } = cmsContent?.ippicaAvvenimentoPage ?? {};

  return (
    <AmbienteContext.Provider value={{ pathScommessa: ['ippica', 'scommessa'], ambiente: 'ippica' }}>
      <Layout
        header={header}
        footer={footer}
        needHelp={needHelp}
        mightLikes={allMightLikes}
        sidebarInstantGame={sidebarInstantGame}
      >
        <Seo siteSeo={site} metaTags={seoMetaTags} canonicalUrl={canonical} />
        <PageContent {...cmsContent} seoData={seoData} />
      </Layout>
    </AmbienteContext.Provider>
  );
};

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  try {
    const cmsData = await getDatoCMSData('common', locale);

    if (!isTruthy(cmsData.config.isActiveIppica)) {
      return {
        notFound: true,
      };
    }

    const { site, header, needHelp, footer, allLabels: labels, sidebarInstantGame, config } = cmsData ?? {};

    const prLiveNae = ssrLiveNav({ rootSlug: AppFragment.Sport, light: true }, locale);
    const prIppicaAvvenimento = getIppicaAvvenimentoPage(locale);
    const [cmsPageData, liveNav] = await Promise.all([prIppicaAvvenimento, prLiveNae]);

    const { allMightLikes, tabsWithAccordionModel, ...cmsContent } = cmsPageData ?? {};

    return {
      props: {
        site,
        footer,
        header,
        labels,
        config: cleanConfig(config),
        liveNav,
        seoData: tabsWithAccordionModel ?? null,
        needHelp,
        cmsContent,
        mightLikes: allMightLikes ?? null,
        sidebarInstantGame,
      },
    };
  } catch (error) {
    console.log('error', error);
    return { notFound: true };
  }
};

export default Ippica;
